import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomerObject } from 'src/app/_interfaces/cinema/CustomerObject';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

const API_URL = environment.prismaApiUrl +'/api/dispo/orders';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  currentObject: any;
  isNew: Boolean = false;
  private apiUrl = environment.apiUrl;
  private currentOrderData = new BehaviorSubject<any>(null);
  private hasChanges = new BehaviorSubject<boolean>(false);

  currentOrderData$ = this.currentOrderData.asObservable();
  hasChanges$ = this.hasChanges.asObservable();

  constructor(private http: HttpClient) { }

  all(): Observable<any> {
    return this.http.get(API_URL);
  }

  getAll(page: number, perPage: number, filterCustomer: number, filterOrderType: number, filterCustomerBranch: number, searchString: string, filterStatus: number, selectedTab: number): Observable<any> {
    return this.http.get(API_URL + '?page=' + page + '&per_page=' + perPage + '&filterCustomer=' + filterCustomer + '&filterOrderType=' + filterOrderType + '&filterCustomerBranch=' + filterCustomerBranch + '&filterStatus=' + filterStatus + '&searchString=' + searchString + '&selectedTab=' + selectedTab
    );
  }

  killAllKillables(): Observable<any> {
    return this.http.get<CustomerObject>(API_URL + '/kill-all-killables');
  } 

  genBackup(): Observable<any> {
    return this.http.get<CustomerObject>(API_URL + '/gen-backup');
  } 

  storeClassParams(id:any, object: any): Observable<any> {
    return this.http.post<CustomerObject>(API_URL + '/store-class-params/' + id, {data: object});
  }

  storeDuration(id: any, object: any): Observable<any> {
    return this.http.post<CustomerObject>(API_URL + '/store-duration/' + id, {data: object});
  }

  storeRekla(id: any, object: any): Observable<any> {
    return this.http.post<CustomerObject>(API_URL + '/store-rekla/' + id, {data: object});
  }

  getGeoCoords(id:any): Observable<any> {
    return this.http.get<CustomerObject>(API_URL + '/get-geo-coords/' + id);
  }

  getOrderHitory(id: any, object: any): Observable<any> {
    return this.http.post<CustomerObject>(API_URL + '/get-order-history/' + id, {data: object});
  }


  getFilter(): Observable<any> {
    return this.http.get(API_URL + '/filter');
  }

  getFields(): Observable<any> {
    return this.http.get(API_URL + '/get_fields');
  }

  search(string): Observable<any> {
    return this.http.get(API_URL + '/search/' + string);
  }

  export(): Observable<any> {
    return this.http.get(API_URL + '/export',{responseType: 'blob'});
  }

  send(): Observable<any> {
    return this.http.get(API_URL + '/send');
  }

  store(object: any): Observable<any> {
    console.log('Store aufgerufen mit:', object);
    const orderData = {
      user_id: 1,
      order_type_id: object.order_type_id,
      customer_id: object.customer_id,
      customer_branch_id: object.customer_branch_id,
      order_number: object.order_number,
      avis_date: object.avis_date,
      forcast: object.forcast,
      status_id: object.status_id || 1,
      color: null,
      archive: null,
      is_prime: true,
      gender_id: object.gender_id,
      first_name: object.first_name,
      last_name: object.last_name,
      street: object.street,
      postal_code: object.postal_code,
      place: object.place,
      country_id: object.country_id,
      phone: object.phone,
      phone_business: object.phone_business,
      mobile: object.mobile,
      fax: object.fax,
      email: object.email
    };
    console.log('Sende an API:', {data: orderData});
    return this.http.post<CustomerObject>(API_URL, {data: orderData});
  }

  copy(object: any): Observable<any> {
    return this.http.post<CustomerObject>(API_URL + '/copy', {data: object});
  }

  dispose(id: any): Observable<any> {
    return this.http.get(API_URL + '/dispose/' + id);
  }

  archive(id: any): Observable<any> {
    return this.http.get(API_URL + '/archive/' + id);
  }

  delete(object: any): Observable<any> {
    return this.http.delete(API_URL + '/' + object.id);
  }

  cacheOrders(): Observable<any> {
    return this.http.get(API_URL + '/cache-orders');
  }

  show(id: any): Observable<any> {
    this.currentObject = this.http.get(API_URL + '/' + id);
    return this.currentObject;
  }

  undispose(id: any): Observable<any> {
    this.currentObject = this.http.get(API_URL + '/undispose/' + id);
    return this.currentObject;
  }

  update(object: any): Observable<any> {
    console.log('Update aufgerufen mit:', object);
    
    // Extrahiere die base-Daten
    const baseData = object.base || object;
    
    // Erstelle die korrekte Datenstruktur für das Update
    const updateData = {
      user_id: 1,
      order_type_id: baseData.order_type_id,
      customer_id: baseData.customer_id,
      customer_branch_id: baseData.customer_branch_id,
      order_number: baseData.order_number,
      avis_date: baseData.avis_date,
      forcast: baseData.forcast,
      status_id: this.currentOrderData.value.base.status_id,
      color: baseData.color,
      archive: baseData.archive,
      is_prime: true,
      root_order: {
        order_number: baseData.order_number,
        user_id: 1,
        customer_id: baseData.customer_id,
        customer_branch_id: baseData.customer_branch_id,
        person: {
          gender_id: baseData.gender_id,
          first_name: baseData.first_name,
          last_name: baseData.last_name,
          street: baseData.street,
          postal_code: baseData.postal_code,
          place: baseData.place,
          country_id: baseData.country_id,
          phone: baseData.phone,
          phone_business: baseData.phone_business,
          mobile: baseData.mobile,
          fax: baseData.fax,
          email: baseData.email,
          level: baseData.level
        }
      }
    };

    console.log('Sende Update an API:', {data: updateData});
    return this.http.put<CustomerObject>(API_URL + '/' + object.id, {data: updateData});
  }

  genPDF(object: any, columns: any, header: any): Observable<any> {
    console.log(columns);
    return this.http.post(API_URL + '/gen-pdf', {data: object.data, columns: columns, header: header}, {responseType: 'blob'});
  }

  genBillingPDF(object: any, billing: any, options: any): Observable<any> {
    return this.http.post(API_URL + '/gen-billing-pdf', {data: object.data, billing: billing, options: options}, {responseType: 'blob'});
  }

  getCurrentObject() {
    return this.currentObject;
  }


  setIsNew(value: any) {
    this.isNew = value;
  }

  getIsNew() {
    return this.isNew;
  }

  // Neue Methoden für die zentrale Datenverwaltung
  setCurrentOrderData(data: any) {
    console.log('setCurrentOrderData aufgerufen mit:', data);
    this.currentOrderData.next(data);
  }

  updateComponentData(componentName: string, data: any) {
    console.log('updateComponentData aufgerufen mit:', { componentName, data });
    const currentData = this.currentOrderData.value || {};
    const updatedData = {
      ...currentData,
      [componentName]: data
    };
    console.log('Aktualisierte Daten:', updatedData);
    this.currentOrderData.next(updatedData);
    this.hasChanges.next(true);
  }

  // Neue Methode zum Markieren von Änderungen
  markAsChanged() {
    this.hasChanges.next(true);
  }

  getComponentData(componentName: string) {
    const currentData = this.currentOrderData.value;
    return currentData ? currentData[componentName] : null;
  }

  saveAllChanges() {
    const currentData = this.currentOrderData.value;
    console.log('saveAllChanges - Aktuelle Daten:', currentData);
    
    if (currentData) {
      // Extrahiere die ID aus den verschiedenen möglichen Stellen
      const orderId = currentData.id || 
                     (currentData.base && currentData.base.id) || 
                     (currentData.data && currentData.data.id);
      
      console.log('Gefundene Order-ID:', orderId);

      if (orderId) {
        console.log('Update vorhandener Auftrag mit ID:', orderId);
        // Stelle sicher, dass die status_id korrekt übergeben wird
        const updateData = {
          ...currentData.base,
          status_id: currentData.base ? currentData.base.status_id : null, // << explizit setzen
          id: orderId
        };
        return this.update(updateData).pipe(
          map(response => {
            this.resetChanges();
            return response;
          })
        );
      } else {
        // Wenn keine ID vorhanden ist, neuen Auftrag speichern
        const baseData = {
          ...currentData.base,
          status_id: currentData.base ? currentData.base.status_id : null // << explizit setzen
        };
        console.log('Speichere neue Daten:', baseData);
        return this.store(baseData).pipe(
          map(response => {
            this.resetChanges();
            if (response && response.data) {
              this.currentOrderData.next({
                ...currentData,
                ...response.data
              });
            }
            return response;
          })
        );
      }
    }
    return null;
  }

  resetChanges() {
    this.hasChanges.next(false);
  }
}
